import React, { Component } from 'react';
import './index.less';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import Table from './table';
import AddForm from './addForm';
import EditForm from './editForm';
import { actUI } from '../../redux/action/ui';
import { PAGE_SIZE } from '../../config';
import CompWrapper from './func';
import { CB_STATUS } from '../../util/fetch/cFetch';
import { msgCB } from '../../util/fetch/msgFetch';

let setIntervalID;
export class Page extends Component {
  componentDidMount() {
    const {
      getAccount, ui, intl, dispatch,
    } = this.props;
    actUI(dispatch, {
      uiHome: { uiMenuSider: { uiMenu: { selectedKeys: ['account'] } } },
    });
    const callback = (res) => {
      const { formatMessage } = intl;
      msgCB(res.status, formatMessage, { all: false, UNAUTH: true });
      if (ui.uiTable.loading) {
        actUI(dispatch, { uiAccount: { uiTable: { loading: false } } });
      }
    };
    setIntervalID = getAccount(
      { limit: PAGE_SIZE, offset: ui.offset },
      callback,
      setIntervalID,
    );
  }

  componentWillUnmount() {
    clearInterval(setIntervalID);
  }

  handleCancel = () => {
    const { dispatch } = this.props;
    actUI(dispatch, { uiAccount: { dialogState: null } });
  }

  handleAddSubmit = (values, cb) => {
    const {
      getAccount, createAccount, ui, dispatch,
    } = this.props;
    const callback = (res) => {
      if (res.status === CB_STATUS.SUCCESS) {
        actUI(dispatch, { uiAccount: { dialogState: 'ADD2' } });
        setIntervalID = getAccount(
          { limit: PAGE_SIZE, offset: ui.offset },
          null,
          setIntervalID,
        );
      }
      cb(res);
    };
    createAccount(values, callback);
  }

  handleEditSubmit = (values, cb) => {
    const {
      getAccount, ui, updateAccount, dispatch,
    } = this.props;
    const callback = (res) => {
      if (res.status === CB_STATUS.SUCCESS) {
        actUI(dispatch, { uiAccount: { dialogState: null } });
        setIntervalID = getAccount(
          { limit: PAGE_SIZE, offset: ui.offset },
          null,
          setIntervalID,
        );
      }
      cb(res);
    };
    updateAccount(values, callback);
  }

  handleDelete = (values, cb) => {
    const { getAccount, deleteAccount, ui } = this.props;
    const callback = (res) => {
      if (res.status === CB_STATUS.SUCCESS) {
        setIntervalID = getAccount(
          { limit: PAGE_SIZE, offset: ui.offset },
          null,
          setIntervalID,
        );
      }
      cb(res);
    };
    deleteAccount(values, callback);
  }

  handleOnChange = (values) => {
    const { getAccount } = this.props;
    setIntervalID = getAccount(values, null, setIntervalID);
  }

  handleAddClick = () => {
    const { dispatch } = this.props;
    actUI(dispatch, { uiAccount: { dialogState: 'ADD1' } });
  }

  handleEditClick = (index) => {
    const { accounts, dispatch } = this.props;
    actUI(dispatch, {
      uiAccount: {
        dialogState: 'EDIT',
        uiEditForm: { data: accounts.results[index] },
      },
    });
  }

  showDialog = () => {
    const {
      ui, devices, getDeviceType, dispatch,
    } = this.props;
    switch (ui.dialogState) {
      case 'ADD1':
        return (
          <AddForm
            onSubmit={this.handleAddSubmit}
            data={devices}
            getDeviceType={getDeviceType}
            onCancel={this.handleCancel}
            ui={ui.uiAddForm}
            dispatch={dispatch}
          />
        );
      case 'ADD2':
      case 'EDIT':
        return (
          <EditForm
            onSubmit={this.handleEditSubmit}
            onCancel={this.handleCancel}
            ui={ui.uiEditForm}
            dispatch={dispatch}
          />
        );
      default:
        return <div>Err Page</div>;
    }
  }

  render() {
    const {
      intl, filePath, className, accounts, ui, dispatch,
    } = this.props;
    const { formatMessage } = intl;
    return (
      <div className={`${filePath} ${className}`}>
        <div className="addBar">
          <Button
            htmlType="button"
            size="small"
            className="addBtn"
            icon="plus"
            onClick={this.handleAddClick}
          >
            <FormattedMessage
              id="Account.addNewAccount"
              defaultMessage="add new account"
            />
          </Button>
        </div>
        <Table
          data={accounts}
          offset={ui.offset}
          onChange={this.handleOnChange}
          onEdit={this.handleEditClick}
          onDelete={this.handleDelete}
          ui={ui.uiTable}
          className="table"
          dispatch={dispatch}
        />
        <Modal
          centered
          closable={false}
          title={
            ui.dialogState === 'ADD1'
              ? formatMessage({
                id: 'Account.addNewAccount',
                defaultMessage: 'add new account',
              })
              : formatMessage({
                id: 'Account.editAccount',
                defaultMessage: 'edit account',
              })
          }
          visible={ui.dialogState !== null}
          maskClosable={false}
          onCancel={this.handleCancel}
          okText={formatMessage({ id: 'app.btn.ok', defaultMessage: 'ok' })}
          cancelText={formatMessage({
            id: 'app.btn.cancel',
            defaultMessage: 'cancel',
          })}
          className="container_account_Main_dialog"
          footer={null}
        >
          {this.showDialog()}
        </Modal>
      </div>
    );
  }
}

Page.propTypes = {
  auth: PropTypes.shape({
    email: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
  }).isRequired,
  accounts: PropTypes.object.isRequired,
  devices: PropTypes.object.isRequired,
  ui: PropTypes.shape({
    dialogState: PropTypes.string,
    offset: PropTypes.number.isRequired,
    uiAddForm: PropTypes.object.isRequired,
    uiEditForm: PropTypes.object.isRequired,
    uiTable: PropTypes.object.isRequired,
  }).isRequired,
  createAccount: PropTypes.func.isRequired,
  updateAccount: PropTypes.func.isRequired,
  deleteAccount: PropTypes.func.isRequired,
  getDeviceType: PropTypes.func.isRequired,
  getAccount: PropTypes.func.isRequired,
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default CompWrapper(Page, 'page_Account');
